
import React, { useContext, useEffect, useMemo, useRef, useState } from 'react';
import { Bubble, Card, DateChangeContext, Justify, Segment, Select } from 'tea-component';
import useStickyFilter from '../../../../../components/Filter/hooks/useStickyFilter';
import { useLocal, } from '../../../../../utils/customHook';
import "./index.scss"
import { getLocale, shallowEqual, useIntl, useSelector } from 'umi';
import { getExplainVal } from '../../../../../utils/getExplainVal';
import MinutesTimePicker from '@/pages/dashboard/components/MinutesTimePicker';
import '@/pages/dashboard/assets/scss/page/RealtimeUsers/index.scss'
import SvgIcon from '@/pages/home/components/SvgIcon';
import { FilterContext } from '@/pages/dashboard/components/PageContainer/context';

//props暂时先用any，因为导入了模拟卡片的函数
const ChangeAnalysisContext = (props: any) => {
  const { config, children, data, changeData, ...restProps } = props
  const { componentSegment = [] } = config || {}
  const { isEN } = useLocal();
  const { formatMessage } = useIntl();
  const { filterVal, setFilterVal } = useContext(FilterContext);
  const explainInfo = useSelector((state: any) => state.dashboard?.explainInfo, shallowEqual);

  const [selectedSegment, setSelectedSegment] = useState(data.is_key_country);
  const [hour, setHour] = useState(data.hour);
  const [trendType, setTrendType] = useState(data.trend_type);
  const [isHover, setIsHover] = useState(false)

  const options = useMemo(() => {
    return componentSegment?.map((item: any) => {
      const { enName, cnName, enTooltip, cnTooltip, rainbowKey, is_key_country, value, disable,  explainEn, explainCn } = item;
      const explain: React.RefObject<HTMLDivElement>[] = getExplainVal(explainInfo, rainbowKey, getLocale(), explainEn, explainCn);
      return {
        text: isEN ? enName : cnName,
        value: is_key_country,
        bubble: explain?.replaceAll('\\n', '<br/>'),
        tooltip: isEN ? enTooltip : cnTooltip,
        disabled: disable !== undefined ? disable : false, //禁用兜底
      }
    })
  }, [componentSegment, isEN])

  const optionsSelect = useMemo(() => ([
    { value: "all", text: formatMessage({ id: "realtime_analysis_All_Trend" }) },
    { value: "same", text: formatMessage({ id: "realtime_analysis_Same_Trend" }) },
    { value: "opposite", text: formatMessage({ id: "realtime_analysis_Opposite_Trend" }) },
  ]), [getLocale()])

  // 处理段选择变化
  const handleSegmentChange = (is_key_country: boolean) => {
    let newRegion;
    if (is_key_country) {
      newRegion = { markets: ["ru", "tr", "us", "br", "mx"] }
      changeData('activeTab', 'popular');

    } else {
      newRegion = { markets: ["255"] };
      changeData('activeTab', 'common');
    }

    setFilterVal({
      ...filterVal,
      region: newRegion,
    });

    setSelectedSegment(is_key_country); // 更新选中的状态
  };

  return (
    <Card className='margin-t-20'>
      <Card.Body>

        <div className='flex-item' >
          <Segment
            className="custom-segment"
            options={options}
            value={selectedSegment} // 设置选中的段
            onChange={(is_key_country) => {
              handleSegmentChange(is_key_country)
              changeData('is_key_country', is_key_country);
            }}
          />
          <div className='dbd-realtime-anylysis-minutes-time-picker'>
            <MinutesTimePicker
              defaultVal='23:59'
              format='HH:mm'
              timeVal={hour}
              onConfirm={(hour) => {
                setHour(hour.format('HH:mm'))
                changeData('hour', hour.format('HH:mm'));
              }}
            />
          </div>
          <Select
            className='margin-select-width'
            // listWidth={160}
            matchButtonWidth
            appearance="button"
            options={optionsSelect}
            value={trendType}
            onChange={(trend_type) => {
              setTrendType(trend_type); // 更新trendType的值
              changeData('trend_type', trend_type);
            }}
          />
          <div onMouseOver={() => { setIsHover(true) }} onMouseOut={() => { setIsHover(false) }} >
            <Bubble
              // trigger={'click'}
              className="realtime-change-analysis__bubble"
              arrowPointAtCenter
              dark
              placement="top-start"
              content={(<>{formatMessage({ id: 'realtime_analysis_tabBubbleText' })} <br /><br /> {formatMessage({ id: 'realtime_analysis_trendTips' })}</>)}
            >
              <div><SvgIcon className='port-icon flex-item-top' type={isHover ? 'alert-circle-action' : 'alert-circle-m'} style={{ width: 16, height: 16 }} /></div>
            </Bubble>
          </div>
        </div>

        <div id="scroll-box">
          {
            React.Children.map(children, (child) => {
              return React.cloneElement(child, {
                ...restProps,

              });
            })
          }
        </div>
      </Card.Body>
    </Card>

  );

}

export default ChangeAnalysisContext
